import {Kbd, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
const shortcutHint = isMac ? '\u2318/' : 'Ctrl+/';

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    minHeight: 50,
    borderBottom: '1px solid #e9ecef',
  },
  iconWrapper: {
    color: '#868e96',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    width: 32,
  },
  input: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: 16,
    background: 'transparent',
    minHeight: 50,
    padding: 0,
    fontFamily: 'inherit',
  },
  kbd: {
    fontSize: 13,
    flexShrink: 0,
    color: '#868e96',
  },
}));

interface OmniboxSearchInputProps {
  query: string;
  onQueryChange: (value: string) => void;
  placeholder: string;
  inputRef: React.RefObject<HTMLInputElement>;
  listboxId?: string;
  activeDescendantId?: string;
  expanded?: boolean;
}

export default function OmniboxSearchInput({
  query,
  onQueryChange,
  placeholder,
  inputRef,
  listboxId,
  activeDescendantId,
  expanded,
}: OmniboxSearchInputProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.iconWrapper}>
        <BenchlingIcon icon="search" />
      </div>
      <input
        ref={inputRef}
        value={query}
        onChange={(e) => {
          onQueryChange(e.target.value);
        }}
        placeholder={placeholder}
        className={classes.input}
        role="combobox"
        aria-autocomplete="list"
        aria-expanded={expanded ?? false}
        aria-controls={listboxId}
        aria-activedescendant={activeDescendantId}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={true}
      />
      {!query && <Kbd className={classes.kbd}>{shortcutHint}</Kbd>}
    </div>
  );
}
